import React from 'react';
import { useSnackbar, Snackbar as FrontonSnackBar, Snack, SnackButton } from 'fronton-react';
import { useClientBreakpoint } from 'common/hooks/use-client-breakpoint';

export const Snackbar = () => {
  const { state, removeSnack } = useSnackbar();
  const isMobileDevice = useClientBreakpoint(bp => bp.atMobile);

  return (
    <FrontonSnackBar data-qa="snackbar" verticalPosition={isMobileDevice ? 'top' : 'bottom'}>
      {state.map(({ id, title, content, icon, variant, button, time, wide, buttonText }) => (
        <Snack
          key={id}
          id={id}
          header={title}
          paragraph={content}
          icon={icon}
          variant={variant}
          wideButton={wide}
          autoHideTimer={time ? 1000 : undefined}>
          {button && <SnackButton onClick={() => removeSnack(id)}>{buttonText || 'Закрыть'}</SnackButton>}
        </Snack>
      ))}
    </FrontonSnackBar>
  );
};
